<h1 class="obg-m-terms-and-conditions-title">{{ data?.title | translate }}</h1>

<ng-container *ngIf="termsAndConditionsHistoryEnabled; else regularTermsAndConditions">
	<mat-tab-group
		class="obg-m-terms-and-conditions-group"
		*ngIf="(isAuthenticated$ | async) && (versionHistory$ | async) as versionHistory; else anonymous"
		[dynamicHeight]="false"
		[selectedIndex]="selectedIndex"
		(selectedTabChange)="selectTab($event.index)"
	>
		<mat-tab class="obg-m-terms-and-conditions-group-tab">
			<ng-template mat-tab-label>
				<span test-id="terms-and-conditions-current-section">
					{{ 'terms-and-conditions.current-version-header' | translate }}
				</span>
			</ng-template>

			<ng-template matTabContent>
				<obg-m-terms-and-conditions-current-version-container
					[document]="data?.document"
					[currentVersion]="versionHistory[0]"
				>
				</obg-m-terms-and-conditions-current-version-container>
			</ng-template>
		</mat-tab>

		<mat-tab class="obg-m-terms-and-conditions-group-tab">
			<ng-template mat-tab-label>
				<span test-id="terms-and-conditions-history-section">
					{{ 'terms-and-conditions.history-header' | translate }}
				</span>
			</ng-template>

			<ng-template matTabContent>
				<obg-m-terms-and-conditions-history-container
					[document]="data?.document"
					[termsAndConditionsDocumentsHistory]="versionHistory"
					[jurisdiction]="jurisdiction"
				>
				</obg-m-terms-and-conditions-history-container>
			</ng-template>
		</mat-tab>
	</mat-tab-group>

	<ng-template #anonymous>
		<obg-m-terms-and-conditions-current-version-container
			[document]="data?.document"
			[currentVersion]="(latestVersion$ | async)"
		>
		</obg-m-terms-and-conditions-current-version-container>
	</ng-template>
</ng-container>

<ng-template #regularTermsAndConditions>
	<obg-m-terms-and-conditions-current-version-container [document]="data?.document">
	</obg-m-terms-and-conditions-current-version-container>
</ng-template>
